module.exports = __webpack_public_path__ + "img/logo.57d577f8.webp";